import React from 'react';
import { X } from 'lucide-react';

export const API_BASE = process.env.REACT_APP_BACKEND_URL || 'http://localhost:8001';

export const getAdminToken = () => localStorage.getItem('adminToken');
// Returns null if not set (do NOT default to super_admin — fail closed)
export const getAdminRole  = () => localStorage.getItem('adminRole') || null;
export const getAdminName  = () => localStorage.getItem('adminName') || 'Admin';
export const isSuperAdmin  = () => getAdminRole() === 'super_admin';

export const colorMap = {
  blue: { card: 'bg-gradient-to-br from-blue-500/20 to-blue-600/10 border-blue-500/20', text: 'text-blue-300', icon: 'text-blue-400', iconBg: 'w-10 h-10 bg-blue-500/20 rounded-lg flex items-center justify-center' },
  emerald: { card: 'bg-gradient-to-br from-emerald-500/20 to-emerald-600/10 border-emerald-500/20', text: 'text-emerald-300', icon: 'text-emerald-400', iconBg: 'w-10 h-10 bg-emerald-500/20 rounded-lg flex items-center justify-center' },
  red: { card: 'bg-gradient-to-br from-red-500/20 to-red-600/10 border-red-500/20', text: 'text-red-300', icon: 'text-red-400', iconBg: 'w-10 h-10 bg-red-500/20 rounded-lg flex items-center justify-center' },
  amber: { card: 'bg-gradient-to-br from-amber-500/20 to-amber-600/10 border-amber-500/20', text: 'text-amber-300', icon: 'text-amber-400', iconBg: 'w-10 h-10 bg-amber-500/20 rounded-lg flex items-center justify-center' },
  purple: { card: 'bg-gradient-to-br from-purple-500/20 to-purple-600/10 border-purple-500/20', text: 'text-purple-300', icon: 'text-purple-400', iconBg: 'w-10 h-10 bg-purple-500/20 rounded-lg flex items-center justify-center' },
  cyan: { card: 'bg-gradient-to-br from-cyan-500/20 to-cyan-600/10 border-cyan-500/20', text: 'text-cyan-300', icon: 'text-cyan-400', iconBg: 'w-10 h-10 bg-cyan-500/20 rounded-lg flex items-center justify-center' },
};

export const formatDate = (d) => d ? new Date(d).toLocaleString('en-IN', { day: '2-digit', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'Asia/Kolkata' }) : '-';

export const formatAmount = (a, currency = 'INR') => {
  const cur = (currency || 'INR').toUpperCase();
  const locale = cur === 'INR' ? 'en-IN' : 'en-US';
  const fractionDigits = cur === 'INR' ? 0 : 2;
  return new Intl.NumberFormat(locale, { style: 'currency', currency: cur, maximumFractionDigits: fractionDigits, minimumFractionDigits: fractionDigits }).format(a);
};

export const Modal = ({ show, onClose, title, children }) => {
  if (!show) return null;
  return (
    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-slate-800 rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden border border-white/10" onClick={e => e.stopPropagation()}>
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <h2 className="text-lg font-semibold text-white">{title}</h2>
          <button onClick={onClose} className="p-2 hover:bg-white/10 rounded-lg"><X className="w-5 h-5 text-slate-400" /></button>
        </div>
        <div className="p-4 overflow-y-auto max-h-[60vh]">{children}</div>
      </div>
    </div>
  );
};
